export default __webpack_public_path__ + "static/media/sales_marketing_module_custom_stage_preview.43d5a25b.png";